import Col from './src/col'

Col.install = app => {
  app.component(Col.name, Col)
}

export default Col;
declare module 'vue' {
    export interface GlobalComponents {
        PtCol: typeof Col;
    }
}
